/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{scaleCorrectors as t}from"../../projection/styles/scale-correction.js";import{transformProps as o}from"../../render/html/utils/transform.js";function r(r,{layout:i,layoutId:s}){return o.has(r)||r.startsWith("origin")||(i||void 0!==s)&&(!!t[r]||"opacity"===r)}export{r as isForcedMotionValue};
//# sourceMappingURL=is-forced-motion-value.js.map
